(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		// 跟踪当前活跃的 mega menu
		let activeMegaMenuLink = null;
		let hideTimeout = null;

		const showMegaMenu = (link) => {
			if (hideTimeout) {
				clearTimeout(hideTimeout);
				hideTimeout = null;
			}
			if (link.classList.contains("list-menu--megamenu")) {
				link.classList.add("list-menu--megamenu-visible");
				activeMegaMenuLink = link;

				menuLinks.forEach((el) => {
					if (el !== link) {
						el.classList.remove("list-menu--megamenu-visible");
					}
				});
			} else {
				menuLinks.forEach((el) => {
					el.classList.remove("list-menu--megamenu-visible");
				});
				activeMegaMenuLink = null;
			}
		};

		const hideMegaMenu = () => {
			hideTimeout = setTimeout(() => {
				menuLinks.forEach((link) => {
					link.classList.remove("list-menu--megamenu-visible");
				});
				activeMegaMenuLink = null;
			}, 100); // 小延迟，让鼠标有时间移动到 mega menu
		};

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				showMegaMenu(link);
			});
			link.addEventListener("focus", (e) => {
				showMegaMenu(link);
			});

			// 为每个 mega menu 添加 mouseenter/mouseleave 事件
			const megaMenu = link.querySelector(".mega-menu");
			if (megaMenu) {
				megaMenu.addEventListener("mouseenter", () => {
					if (hideTimeout) {
						clearTimeout(hideTimeout);
						hideTimeout = null;
					}
				});
				megaMenu.addEventListener("mouseleave", () => {
					hideMegaMenu();
				});
			}
		});
		menu.addEventListener("mouseleave", (e) => {
			hideMegaMenu();
		});
		menu.addEventListener("focusout", (e) => {
			menuLinks.forEach((link) => {
				link.classList.remove("list-menu--megamenu-visible");
			});
		});

		const megaMenuTabs = () => {
			$(".mega-menu__tab-wrapper")
				.children()
				.find(".mega-menu__tab-wrapper")
				.first()
				.addClass("mega-menu__tab-wrapper--active");
			$(".mega-menu__tab-wrapper").mouseenter(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
			$(".mega-menu__tab-wrapper").focus(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
			$(".mega-menu__tab-wrapper").focusin(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
		};
		megaMenuTabs();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main.querySelectorAll(".shopify-section")[0] &&
			main
				.querySelectorAll(".shopify-section")[0]
				.classList.contains("section--has-overlay")
		) {
		}

		const menuCloseBtn = document.querySelector(".header__modal-close-button");
		const mobileMenuDrawer = document.querySelector("header-drawer");
		menuCloseBtn.addEventListener("click", (e) => {
			mobileMenuDrawer.closeMenuDrawer(e);
		});
	};

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);

	header();
})();
